const statisticsPl = {
    "user_statistics": "Statystyki użytkownika",
    "menu_item_clicks": "Kliknięcia elementów menu",
    "statistics": "Statystyka",
    "user_traffic": "Ruch użytkowników",
    "last_7_days": "Ostatnie 7 dni",
    "last_30_days": "Ostatnie 30 dni",
    "menu_item": "Pozycja menu",
    "click_count": "Liczba kliknięć",
    "error_fetching_user_statistics": "Błąd podczas pobierania statystyk użytkownika.",
    "error_fetching_menu_item_statistics": "Błąd podczas pobierania statystyk pozycji menu.",
    "statistics_feature_not_available": "Funkcja statystyk jest dostępna tylko w planie PRO. Aby uzyskać dostęp do tej funkcji, należy uaktualnić subskrypcję.",
    "change_subscription_plan": "Zmień plan subskrypcji",
    "permission_denied": "Odmowa pozwolenia",
    "error_fetching_rating_statistics": "Błąd podczas pobierania statystyk ocen.",
    "menu_item_ratings": "Oceny pozycji menu",
    "likes": "upodobania",
    "dislikes": "nie lubi",
    "rating_trends_last_7_days": "Trendy ocen (ostatnie 7 dni)",
    "rating_trends_last_30_days": "Trendy ocen (ostatnie 30 dni)"
};

export default statisticsPl;
